import React from 'react'

import PageContainer from '../../components/page-container/PageContainer'
import Spacer from '../../components/spacer/Spacer'
import TextElement from '../../components/text/Text'
import { FormTarget, FormContainer, FormIframe } from './styled'

const QuoteCalculator = (): JSX.Element => (
  <PageContainer
    offsetLeft="20px"
    offsetRight="20px"
    offsetMode="padding"
    allowNotifications={true}
    allowUnauthenticated={false}>
    <Spacer direction="vertical" amount="20px" display="block" />
    <TextElement
      text="Cost of Materials"
      theme="h1"
      alignment="center"
      display="block"
    />
    <Spacer direction="vertical" amount="10px" display="block" />
    <TextElement
      text="Complete the fields below to calculate the estimated cost of your project."
      theme="paragraph"
      alignment="center"
      display="block"
    />
    <Spacer direction="vertical" amount="40px" display="block" />
    <FormContainer>
      <FormTarget
        className="op-interactive"
        id="642323f4b1c8a87eb79b4ff2"
        data-title="Materials Estimator"
        data-url="https://stormflowsurfacing.outgrow.us/642323f4b1c8a87eb79b4ff2?vHeight=1">
        <FormIframe
          title="Materials Estimator"
          src="https://stormflowsurfacing.outgrow.us/642323f4b1c8a87eb79b4ff2?custom=1&seamless=1"
        />
      </FormTarget>
    </FormContainer>
  </PageContainer>
)

export default QuoteCalculator
